class reports {
  constructor(id, name, description, process, parameters, type, operId, tags, permission) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.process = process;
    this.parameters = parameters;
    this.type = type == "Pr" ? "Privado" : "Público";
    this.operId = operId;
    this.tags = tags;
    this.permission = permission;
  }
  static fromJson({
    reporteId,
    nombre,
    descripcion,
    procedimiento,
    parametros,
    tipoRep,
    operId,
    etiquetas,
    rolPermsio
  }) {
    return new reports(
      reporteId,
      nombre,
      descripcion,
      procedimiento,
      parametros,
      tipoRep,
      operId,
      etiquetas,
      rolPermsio
    );
  }
}
export default reports;
